import type { ChangeEvent } from 'react';
import { forwardRef } from 'react';
import type { BasicInputProps } from '../basic-input';
import { BasicInput } from '../basic-input';

type NumberInputProps = Omit<BasicInputProps, 'type'>;

export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ onInput, ...rest }, ref) => {
    const restrictToNumbers = (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      if (!isNaN(Number(value))) {
        onInput?.(event);
      } else {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    return (
      <BasicInput
        ref={ref}
        type="number"
        {...rest}
        onInput={restrictToNumbers}
      />
    );
  }
);

NumberInput.displayName = 'NumberInput';
